// Copyright (c) Docugami, Inc. All rights reserved.

export function sleep(timeMs: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, timeMs));
}
